module.exports = __webpack_public_path__ + "media/icons/linkedin-f2d64125.png";